import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { DivBackgroundOpacity, ListLinkContainer } from "@utils/extra-style";
import "@utils/extra-style.scss";

const CompanyId = (props) => {
  const { t, data, id, isActive } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={isActive === 1 ? 1 : "0.2"}>
        <ListLinkContainer>
          <Link
            to={`/company/view/${id}/general-info`}
            className="listing__link-info"
          >
            {data}
          </Link>
        </ListLinkContainer>
      </DivBackgroundOpacity>
    </>
  );
};

CompanyId.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CompanyId);
